<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information"><div style="padding-top:180px">
<p>But now the sounds of population fail,</p>
<p>No cheerful murmurs fluctuate in the gale,</p>
<p>No busy steps the grass-grown footway tread,</p>
<p>But all the blooming flush of life is fled.</p><br/>
<p><strong><em>Oliver Goldsmith</em></strong> (The Deserted Village)</p><br/>
<p>They say there’s tanks and armoured cars,</p>
<p>And guns that fire like hell,</p>
<p>I wonder if the skylark sings</p>
<p>On the plain I knew so well?</p><br/>
<p style="text-indent:12em">(Salisbury Plain)</p>
<p style="text-indent:15em">C.H.C.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?731c8dd4